import React, { useState, useEffect } from "react";
import { FiX, FiFolder, FiSave } from "react-icons/fi";
import styles from "../css/shared.module.css";

const BrainSectionModal = ({ isOpen, onClose, section, onSave }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  // Resetear formulario cuando se abre/cierra el modal
  useEffect(() => {
    if (isOpen) {
      if (section) {
        // Modo edición
        setTitle(section.title || "");
        setDescription(section.description || "");
      } else {
        // Modo creación
        setTitle("");
        setDescription("");
      }
      setError("");
    }
  }, [isOpen, section]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!title.trim()) {
      setError("El título del Brain es requerido");
      return;
    }

    setIsSubmitting(true);
    setError("");

    try {
      if (section) {
        // Modo edición
        await onSave(section._id, title.trim(), description.trim());
      } else {
        // Modo creación
        await onSave(title.trim(), description.trim());
      }
    } catch (err) {
      setError("Error al guardar el Brain");
      console.error("Error saving section:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={handleClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <div className={styles.modalTitle}>
            <FiFolder size={20} />
            <span>{section ? "Editar Brain" : "Nuevo Brain"}</span>
          </div>
          <button
            onClick={handleClose}
            className={styles.modalCloseButton}
            disabled={isSubmitting}
          >
            <FiX size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.modalForm}>
          <div className={styles.modalBody}>
            {error && (
              <div className={styles.errorMessage}>
                {error}
              </div>
            )}

            <div className={styles.formGroup}>
              <label htmlFor="sectionTitle" className={styles.formLabel}>
                Título del Brain *
              </label>
              <input
                id="sectionTitle"
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className={styles.input}
                placeholder="Ej: Conceptos de Programación"
                disabled={isSubmitting}
                required
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="sectionDescription" className={styles.formLabel}>
                Descripción (opcional)
              </label>
              <textarea
                id="sectionDescription"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className={`${styles.input} ${styles.textarea}`}
                placeholder="Describe brevemente qué contiene este Brain..."
                rows={3}
                disabled={isSubmitting}
              />
            </div>
          </div>

          <div className={styles.modalFooter}>
            <button
              type="button"
              onClick={handleClose}
              className={`${styles.button} ${styles.secondary}`}
              disabled={isSubmitting}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className={`${styles.button} ${styles.primary}`}
              disabled={isSubmitting || !title.trim()}
            >
              <FiSave size={16} />
              <span>{isSubmitting ? "Guardando..." : "Guardar"}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BrainSectionModal;
